import md5 from 'md5';

function getGravatarUrl(email) {
    var md5value = md5(email.trim().toLowerCase());
    return `https://www.gravatar.com/avatar/${md5value}`;
}

export default getGravatarUrl;